export default "__VITE_ASSET__xQyAzFeD__"